import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FnCoreModule } from '../../core/index';
import { FnInputModule } from '../input/index';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FnTelInputComponent } from './fn-tel-input.component';
import { FnTelInput } from './fn-tel-input';

export * from './fn-tel-input.component';
export * from './fn-tel-input';

@NgModule({
  declarations: [FnTelInputComponent, FnTelInput],
  imports: [
    CommonModule,
    FnInputModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FnInputModule,
    FnInputModule.forRoot(),
    FnCoreModule
  ],
  exports: [FnTelInputComponent, FnTelInput]
})
export class FnTelInputModule {
  static forRoot(): ModuleWithProviders<FnTelInputModule> {
    return {
        ngModule: FnTelInputModule,
        providers: []
    }
}
}
